import React from "react";

const TextSkeleton = ({ width }) => {
  return <div className={`h-2.5 bg-gray-300 rounded-full ${width}`}></div>;
};

export default TextSkeleton;
